import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Support from './pages/Support';
import Privacy from './pages/Privacy';
import './App.css';

function App() {
  return (
    <Router basename="/mathscope">
      <div className="App">
        <header className="header">
          <div className="container">
            <h1 className="logo">数学可视化引擎</h1>
            <nav className="nav">
              <Link to="/" className="nav-link">支持</Link>
              <Link to="/privacy" className="nav-link">隐私政策</Link>
            </nav>
          </div>
        </header>
        
        <main className="main">
          <Routes>
            <Route path="/" element={<Support />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </main>
        
        <footer className="footer">
          <div className="container">
            <p>&copy; {new Date().getFullYear()} 李光浩. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
